import React, { Component } from 'react'
import { appendToFormData } from '../../helpers/utility'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import * as MabnaButton from './Button/Button'
import { SENT_MESSAGE_REQUEST } from '../../actions/actions'
import { NotificationManager } from 'react-notifications'
import { browserHistory } from 'react-router'

const styles = {
  textarea: {
    width: '95%',
    padding: '10px',
  },
}

class ComposeMessage extends Component {
  text = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <div style={{ width: '100%' }}>
        <textarea
          style={styles.textarea}
          rows={4}
          name="info"
          id="info"
          placeholder="متن پیام"
          {...input}
          {...custom}
        />
        <div className="form-error">{hasError && error}</div>
      </div>
    )
  }

  handleSubmit = values => {
    const { dispatch, userType, receiverId } = this.props
    let formData = appendToFormData(values)

    if (userType === 'MANAGER') {
      // add receiver if manager is sending a message
      formData.append('receiver', receiverId)
    }

    return new Promise((resolve, reject) => {
      dispatch({
        type: SENT_MESSAGE_REQUEST,
        formData,
        resolve,
        reject,
      })
    })
      .then(data => {
        NotificationManager.success('پیام شما ثبت شد', null, 6000)
        if (userType === 'MANAGER') {
          this.props.onSuccess()
        } else {
          browserHistory.push('/dashboard/messages')
        }
      })
      .catch(errors => {
        throw new SubmissionError({
          _error: errors.general_errors[0],
          ...errors.form_errors,
        })
      })
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <section className="compose-message message-page">
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Field name="text" component={this.text} />
          <MabnaButton.Primary type="submit" value="Submit" outline>
            ارسال
          </MabnaButton.Primary>
        </form>
      </section>
    )
  }
}

const validate = values => {
  let errors = {}

  if (!values.text) {
    errors.text = 'متن پیام جهت ارسال پیام به مدیریت الزامی است'
  }

  return errors
}

ComposeMessage = reduxForm({
  form: 'ComposeMessage',
  validate,
})(ComposeMessage)

const mapStateToProps = state => {
  return {
    userType: state.auth.userType,
  }
}

export default connect(mapStateToProps)(ComposeMessage)



// WEBPACK FOOTER //
// ./src/components/common/ComposeMessage.js